var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'アーカイブされたイベントの確認方法'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          WeRUN公式サイトから"),_c('b',[_vm._v("管理者ページ")]),_vm._v("にログインし、「イベント」メニューにて「開催中のイベント」、「まもなく開始するイベント」、「終了したイベント」をご確認いただけます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ae17d8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpAdmin99.vue
// module id = okcK
// module chunks = 0